export const formatCurrency = (amount) => {
    const formattedAmount = Math.abs(amount).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    return amount < 0 ? `-${formattedAmount}` : formattedAmount;
  };

/** `$12.34` or `-$0.00` — minus sits before `$` (never `$-0.00`). */
export const formatSignedCurrency = (amount) => {
    const n = typeof amount === "number" ? amount : parseFloat(amount);
    if (!Number.isFinite(n)) return "$0.00";
    const fixed = n.toFixed(2);
    if (fixed.startsWith("-")) return `-$${fixed.slice(1)}`;
    return `$${fixed}`;
  };